import React from 'react';
import withStyles from 'react-jss';
import Truncate from 'react-truncate';

const actionPlanCardStyles = {
  backgroundColor: (props) => ({
    backgroundColor: props.staySelected ? props.tenant.secondary : 'white',
    border: '2px solid #CECECE',
    borderBottom: `5px solid ${props.tenant.secondary}`,

    '&:hover': {
      border: `3px solid ${props.tenant.secondary}`,
    },
  }),
  degreeText: () => ({
    color: '#555555',
  }),
};

function CareerCardBottom(props) {
  const { careerTitleEn, degreeTitleEn } = { ...props };

  return (
    <div className={['card-bottom', props.classes.backgroundColor].join(' ')}>
      <p className="card-bottom-career-text">
        {' '}
        <Truncate lines={1} ellipsis="...">
          {careerTitleEn}
        </Truncate>
      </p>

      <p
        className={['card-bottom-degree-text', props.classes.degreeText].join(
          ' '
        )}
      >
        <Truncate lines={1} ellipsis="...">
          {degreeTitleEn}
        </Truncate>
      </p>
    </div>
  );
}

export default withStyles(actionPlanCardStyles)(CareerCardBottom);
